<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';

  /* custom padding for child element of navigate menu bar*/
  .c-sidebar-nav-dropdown-items li.c-sidebar-nav-item {
    .c-sidebar-nav-icon {
      padding-left: 1rem;
    }
  }

  .swal2-confirm,
  .swal2-cancel {
    min-width: 120px;       /* same width */
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 8px;

    box-shadow: none !important;   /* remove default shadow */
    border: none;                  /* remove default border */
  }

  /* style confirm */
  .swal2-confirm {
    background-color: #3085d6;
    color: #fff;
  }

  /* style cancel */
  .swal2-cancel {
    background-color: #aaa;
    color: #fff;
  }
</style>
